module.exports = __webpack_public_path__ + "img/12.4e7cddb7.png";